import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpCheckboxComponent from './adpCheckbox.component';

let adpCheckboxModule = angular.module('adpCheckbox', [
  uiRouter
])

.component('adpCheckbox', adpCheckboxComponent)

.name;

export default adpCheckboxModule;



// WEBPACK FOOTER //
// ./src/app/components/adpCheckbox/adpCheckbox.js